import { t } from '../../../locales';
import { featureFlag } from '../../entities/feature-flag';

const verifySyRoutes = {
	path: 'verify-sy',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: [featureFlag.VERIFY_SY, featureFlag.ECOMMERCE_AI, featureFlag.REAL_ESTATE, featureFlag.AI_AGENT],
	},
	children: [
		{
			path: 'facts',
			component: () => import('./pages/facts/index.vue'),
			meta: {
				title: t('verify-sy.facts'),
			},
		},
		{
			path: 'facts/create',
			component: () => import('./pages/facts/form.vue'),
			meta: {
				title: t('verify-sy.create-fact'),
			},
		},
		{
			path: 'facts/:id/edit',
			component: () => import('./pages/facts/form.vue'),
			meta: {
				title: t('verify-sy.edit-fact'),
			},
		},
		{
			path: 'tasks',
			component: () => import('./pages/tasks/index.vue'),
			meta: {
				title: t('verify-sy.tasks'),
			},
		},
		{
			path: 'task-groups',
			component: () => import('./pages/task-groups/index.vue'),
			meta: {
				title: t('verify-sy.task-groups'),
			},
		},
		{
			path: 'faqs',
			component: () => import('./pages/faqs/index.vue'),
			meta: {
				title: t('verify-sy.faqs'),
			},
		},
	],
};

export { verifySyRoutes };
